import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Checkbox} from 'antd';
import { FormattedMessage} from 'react-intl';
import { fetchUsers } from '../actions/users';
import SearchTable from './SearchTable'
import LoadingControl from './Loading';
import { compareStrings } from '../utils/utils';

class UsersSelectTable extends Component {

    constructor(props) {
        super(props);

        if (this.props.user_id !== undefined)
        {
            // отмеченные принтеры в отчете переставляем в начало таблицы
            this.props.users.sort((x, y) => { return x.id === this.props.user_id ? -1 : y.id === this.props.user_id ? 1 : 0; });
        }

        this.state = {
            showUsers: this.props.user_id === undefined ? false : true,
            selectedRowKeys: this.props.user_id === undefined ? [] : [this.props.user_id],
          };

        this.layout = {
            bordered : true,
            showSizeChanger : false, 
            pagination : {pageSize: 10, showSizeChanger: false},
            size: "small",
            rowKey : record => record.id,
        };

        this.columns = [
            {
              title: <FormattedMessage id="Username"/>,
              dataIndex: 'name',
              sorter: {
                compare: (a, b) => compareStrings(a.name, b.name)
              },
              search: true,
            },
            {
              title: <FormattedMessage id="FullName"/>,
              dataIndex: 'fullName',
              sorter: {
                compare: (a, b) => compareStrings(a.fullName, b.fullName)
              },
              search: true,
            },
        ];   
      }
      
    componentDidMount() {  
        if (this.props.users === undefined || this.props.users.length === 0)
        {
            this.props.fetchData();
        }
    }

    onAllUsers(e)
    {
        this.setState({showUsers: !e.target.checked});

        if (this.props.onSelectChange !== undefined && e.target.checked)
        {
            this.props.onSelectChange([undefined]);
        }
    }

    onSelectChange(selectedRowKeys) {
        if (this.props.onSelectChange !== undefined)
        {
            this.props.onSelectChange(selectedRowKeys);
        }
    }

    render() {
        if(this.props.hasError != null)
        {
          return (
            <div><h3>{this.props.hasError.message}</h3></div>
          );
        }
        else if (this.props.isLoading)
        {
          return (
            <div><LoadingControl size="small"/></div>
          );
        }
        else
        {
            return (
                <div>
                    <Checkbox checked={!this.state.showUsers} onChange={(e) => this.onAllUsers(e)}><FormattedMessage id="AllUsers"/></Checkbox>
                    <br></br><br></br>
                    {this.state.showUsers && 
                                        <SearchTable
                                            layout = {this.layout}
                                            type = "radio"
                                            onSelectChange = {(selectedRowKeys) => this.onSelectChange(selectedRowKeys)}
                                            initialSelection={this.state.selectedRowKeys}
                                            columns={this.columns} 
                                            dataSource={this.props.users} />
                        }
                </div>
            );
        }
      }
}
const mapStateToProps = (state) => {
    return {
        users: state.users,
        hasError: state.usersHasError,
        isLoading: state.usersIsLoading
    };
  };

const mapDispatchToProps = (dispatch) => {
return {
    fetchData: () => dispatch(fetchUsers()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersSelectTable);